const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

const themeShim = {
  breakpoints: {
    down: (key) => '@media (max-width:' + (breakpointValues[key] || key) + 'px)',
  },
};

let styleCounter = 0;

function toKebabCase(value) {
  return value.replace(/[A-Z]/g, (match) => '-' + match.toLowerCase());
}

function styleObjectToCss(selector, styles) {
  const declarations = [];
  const nested = [];

  Object.entries(styles).forEach(([property, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (property.startsWith('&')) {
      nested.push(styleObjectToCss(property.replace('&', selector), value));
      return;
    }

    if (property.startsWith('@media')) {
      nested.push(property + '{' + styleObjectToCss(selector, value) + '}');
      return;
    }

    const cssValue = typeof value === 'number' && property !== 'fontWeight' && property !== 'lineHeight'
      ? value + 'px'
      : value;
    declarations.push(toKebabCase(property) + ':' + cssValue + ';');
  });

  return selector + '{' + declarations.join('') + '}' + nested.join('');
}

function injectStyles(id, css) {
  if (typeof document === 'undefined') {
    return;
  }

  let style = document.getElementById(id);
  if (!style) {
    style = document.createElement('style');
    style.id = id;
    document.head.appendChild(style);
  }
  style.textContent = css;
}

export function makeStyles(styleCreator) {
  const sheetId = 'local-make-styles-' + styleCounter++;

  return function useLocalStyles() {
    const styles = styleCreator(themeShim);
    const classes = {};
    const css = Object.entries(styles).map(([key, value]) => {
      const className = sheetId + '-' + key;
      classes[key] = className;
      return styleObjectToCss('.' + className, value);
    }).join('');

    injectStyles(sheetId, css);
    return classes;
  };
}
